import { CATEGORIES, ACC_TYPES, categoryOf, accTypeOf, conditionLabel } from "@/lib/store";

export const fold = (s = "") => String(s).normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase().trim();

const haystack = (p) => fold([
  p.model, p.storage, p.color, p.wattage,
  CATEGORIES.find((c) => c.id === categoryOf(p))?.label,
  categoryOf(p) === "acessorios" ? ACC_TYPES.find((t) => t.id === accTypeOf(p))?.single : conditionLabel(p),
  ...(Array.isArray(p.compatible) ? p.compatible : []),
].filter(Boolean).join(" "));

export const searchProducts = (products, query) => {
  const tokens = fold(query).split(/\s+/).filter(Boolean);
  if (!tokens.length) return [];
  return (Array.isArray(products) ? products : []).filter((p) => {
    const text = haystack(p);
    return tokens.every((t) => text.includes(t));
  });
};

const GUESS = [
  [/capa|pelicula|fonte|cabo|carregador|loop|hprime|acessorio/, "acessorios"],
  [/macbook|\bmac\b/, "macbook"],
  [/ipad/, "ipad"],
  [/watch|relogio/, "watch"],
  [/airpod|fone/, "airpods"],
];

export const guessCategory = (query) => GUESS.find(([re]) => re.test(fold(query)))?.[1] || "iphone";
